import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { SystemAdminDto, PaginateQuery } from "../../interfaces";

export const systemAdminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSystemAdminUsers: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, `/api/user/system-admin`),
      }),
      providesTags: ["Paginated-System-Admins"],
    }),
    getSystemAdminUser: builder.query<SystemAdminDto, string>({
      query: (id) => ({
        url: `/api/user/system-admin/${id}`,
      }),
      providesTags: ["SystemAdmin"],
    }),
    addSystemAdminUser: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/user/system-admin",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Paginated-System-Admins"],
    }),
    updateSystemAdminUser: builder.mutation<
      any,
      { id: string; data: any }
    >({
      query: ({ id, data }) => ({
        url: `/api/user/system-admin/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Paginated-System-Admins", "SystemAdmin"],
    }),
    deleteSystemAdminUser: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-System-Admins"],
    }),
  }),
});

export const {
  useGetSystemAdminUsersQuery,
  useGetSystemAdminUserQuery,
  useAddSystemAdminUserMutation,
  useUpdateSystemAdminUserMutation,
  useDeleteSystemAdminUserMutation,
} = systemAdminApi;
